import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import type { StatusCardProps as Props } from './types';

export const StatusCard = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('StatusCard', className)}
      icon={false}
      severity="warning"
    >
      There was an issue with your payment. Please check your details and try
      again.
    </Styled.Wrapper>
  );
});

StatusCard.displayName = 'StatusCard';
